import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable */
const Icon = ({
  component: Component, size="24px", className, ...restProps
}) => {

  const iconSize = { fontSize: (size) };

  return (
    <Component
      className={`vert-markeplace-icon ${className || ''}`}
      style={iconSize}
      {...restProps}
    />
  );
};

Icon.propTypes = {
  size: PropTypes.string,
};

export default Icon;
